'use client';

import { MixerHorizontalIcon } from '@radix-ui/react-icons';
import { FC, useState } from 'react';
import { cn } from '../utils/cn';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
type ToolbarProps = {
  className?: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  Search?: React.ReactNode;
  tabs?: React.ReactNode;
  children?: React.ReactNode;
  category?: string;
  suppressMobileMenu?: boolean;
};
const DesktopToolbar: FC<ToolbarProps> = ({
  children,
  className,
  variant = 'primary',
  Search,
  tabs: Tabs,
  suppressMobileMenu
}) => <div className={cn('px-2 lg:px-4 py-4 gap-1 xl:gap-2 border-b lg:rounded', {
  'hidden lg:flex': !suppressMobileMenu,
  'bg-zinc-100': variant === 'primary',
  'bg-zinc-50': variant === 'secondary',
  'bg-transparent border-none': variant === 'ghost'
}, className)} data-sentry-component="DesktopToolbar" data-sentry-source-file="toolbar.tsx">
    {children}
    {Search}
    {Tabs}
  </div>;
const MobileToolbar: FC<ToolbarProps> = ({
  children,
  className,
  variant = 'primary',
  Search,
  tabs,
  category
}) => {
  const [showFilters, setShowFilters] = useState(false);
  return <div className={cn('p-4 gap-2 items-stretch flex lg:hidden relative', className)} data-sentry-component="MobileToolbar" data-sentry-source-file="toolbar.tsx">
      <div className="flex-1">{Search}</div>
      <div className="h-10">
        <Button variant="link" size="sm" className="border border-gray-400 h-full rounded-md" onClick={() => setShowFilters(true)} data-sentry-element="Button" data-sentry-source-file="toolbar.tsx">
          <MixerHorizontalIcon data-sentry-element="MixerHorizontalIcon" data-sentry-source-file="toolbar.tsx" />
        </Button>
      </div>
      <Dialog open={showFilters} onOpenChange={setShowFilters} modal data-sentry-element="Dialog" data-sentry-source-file="toolbar.tsx">
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="toolbar.tsx">
          <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="toolbar.tsx">
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="toolbar.tsx">Filters</DialogTitle>
          </DialogHeader>
          <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="toolbar.tsx">
            <div className="flex flex-col p-4 space-y-2">
              {children}
              <div className="absolute bottom-4 w-full flex justify-center px-8 left-0">
                <Button className="w-full capitalize" onClick={() => setShowFilters(false)} data-sentry-element="Button" data-sentry-source-file="toolbar.tsx">
                  {category ? `View ${category}` : 'Save'}
                </Button>
              </div>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>
      {tabs ? <div className="flex">{tabs}</div> : null}
    </div>;
};
export const Toolbar: FC<ToolbarProps> = props => <>
    <DesktopToolbar {...props} data-sentry-element="DesktopToolbar" data-sentry-source-file="toolbar.tsx" />
    {!props.suppressMobileMenu && <MobileToolbar {...props} />}
  </>;